import { EnglishArabicDTO } from "bnsights-control-library"
import { EmailTemplateInfoDTO } from "./EmailTemplateInfoDTO";
import { SMSTemplateInfoDTO } from "./SMSTemplateInfoDTO";
export class TemplateEditViewModel
{
      ID:number
      IDEncrypted :string
      TemplateName :string
      IsEmail :boolean
      IsSms :boolean
      Language:string
      smstemplateinfo:SMSTemplateInfoDTO= new SMSTemplateInfoDTO();
      emailtemplateinfo:EmailTemplateInfoDTO=new EmailTemplateInfoDTO();
}
   